import React, { useMemo } from 'react';
import Flag from 'react-world-flags';
import Avatar from '../../components/Avatar';
import { buildAvatarMatrix } from '../../utils/avatarMatrix';
import { useTranslation } from '../../contexts/TranslationContext';

interface RegisterProfilePreviewProps {
  name: string;
  country: string;
  avatarColor1: string;
  avatarColor2: string;
  avatarSeed: number;
  tags: string[];
  description?: string;
}

const RegisterProfilePreview: React.FC<RegisterProfilePreviewProps> = ({
  name,
  country,
  avatarColor1,
  avatarColor2,
  avatarSeed,
  tags,
  description,
}) => {
  const { t } = useTranslation();
  const matrix = useMemo(() => buildAvatarMatrix(avatarSeed), [avatarSeed]);
  const displayName = name.trim() || t.register.previewNamePlaceholder;
  const shownTags = tags.filter(Boolean).map((tag) => t.sports[tag] ?? tag);

  return (
    <div className="register-preview">
      <div className="expert-list-row register-preview__row">
        <div className="expert-list-row__avatar-col">
          <Avatar matrix={matrix} color1={avatarColor1} color2={avatarColor2} compact />
        </div>

        <div className="expert-list-row__identity">
          <div className="expert-list-row__name-row">
            <span className="expert-list-row__name">{displayName}</span>
            {country && (
              <span className="expert-list-row__country-pill">
                <Flag code={country} />
                <span>{country}</span>
              </span>
            )}
          </div>

          {shownTags.length > 0 && (
            <div className="expert-list-row__sub-row">
              <span className="expert-list-row__tags">{shownTags.join(' · ')}</span>
            </div>
          )}
        </div>
      </div>

      {description && <p className="register-preview__description">{description}</p>}
    </div>
  );
};

export default RegisterProfilePreview;
